import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { classNames } from "../../utils/helpers";
import { View } from "../view";
import s from './Skeleton.module.css';
export const Skeleton = (props) => {
    const { borderRadius, width, height, className, attributes, noAnimation } = props;
    const rootClassNames = classNames(s.root, className, noAnimation && s['no-animation']);
    return (_jsx(View, { backgroundColor: "disabled", width: width, height: height, borderRadius: borderRadius, className: rootClassNames, attributes: attributes }));
};
